const theme = {
  direction: "ltr",
  palette: {
    primary: {
      main: "#418DF0",
    },
    secondary: {
      main: "#111827",
      light: "#555555",
    },
    border: {
      blue: "#E0E9FB",
      grey: "#E7E7E7",
      blueLight: "#C0EAD6"
    },
    yellow: {
      main: "#FFDDA1",
      light: "#FFF7E8",
    },
    warning: {
      main: "#FFDDA1",
    },
    white: {
      main: "#ffffff",
    },
    purple: {
      main: "#B6A1FF",
      light: "#F3F0FF",
    },
    success: {
      main: "#26B673",
      light: "#B1F2C2",
    },
    error: {
      main: "#E53535",
      light: "#FFEEEE",
    },
    background: {
      default: "#EDF2FC",
      paper: "#ffffff",
      blue: "#1A2748",
      blueLight: "#F0FFF8",
      success: 'red',
    },
  },
  typography: {
    fontFamily: "'Barlow', sans-serif",
    // fontFamily: "Rajdhani, Tajawal"
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: "title" },
          style: {
            fontSize: "18px",
          },
        },
        {
          props: { variant: "subtitle" },
          style: {
            fontSize: "16px",
          },
        },
        {
          props: { variant: "body1" },
          style: {
            fontSize: "14px",
          },
        },
        {
          props: { variant: "body2" },
          style: {
            fontSize: "12px",
            lineHeight: "normal",
          },
        },
      ],
    },
    MuiTextField: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          "&>div": {
            borderRadius: "8px !important",
            fontSize: "14px",
            "& fieldset": {
              borderColor: theme.palette.border.grey,
              borderWidth: "1px !important",
              ...(ownerState?.noBorder && {
                border: "none",
              }),
            },
            ...(ownerState?.filled && {
              background: theme.palette?.[ownerState?.filled || "white"]?.main,
            }),
          },
        }),
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState?.label && {
            color: theme.palette.secondary.main,
            marginBottom: "5px",
            fontSize: "14px",
            "&>span": {
              color: "red",
            },
          }),
        }),
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: "0px",
          marginTop: "2px",
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: "contained" },
          style: {
            textTransform: "none",
            borderRadius: "8px",
            boxShadow: "none !important",
          },
        },
        {
          props: { variant: "outlined" },
          style: {
            textTransform: "none",
            borderRadius: "8px",
            boxShadow: "none !important",
          },
        },
      ],
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState?.iconbutton && {
            minWidth: "auto",
            padding: "6px",
            "&>svg": {
              height: "25px",
              width: "25px",
            },
          }),
          ...(ownerState?.outlinedFilled && {
            color: theme.palette.secondary.main,
            background: theme.palette.background.default,
          }),
        }),
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState?.grey && {
            "&::before": {
              borderColor: theme.palette.border.grey,
            },
            "&::after": {
              borderColor: theme.palette.border.grey,
            },
          }),
        }),
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          borderRadius: "8px !important",
          "& fieldset": {
            borderColor: theme.palette.border.grey,
            borderWidth: "1px !important",
          },
        }),
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState?.primary && {
            width: "100%",
            borderRadius: "10px",
            backgroundColor: theme.palette.background.default,
            "&>span": {
              borderRadius: "10px",
            },
          }),
        }),
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState?.outlined && {
            borderRadius: "32px",
            padding: "4px 8px",
            height: "auto",
            background: `${
              theme.palette[ownerState?.color || "primary"].main
            }20`,
            "& span": {
              padding: "0px",
            },
          }),
          ...(ownerState?.filled && {
            borderRadius: "30px",
            padding: "4px 16px",
            height: "auto",
            background: `${
              theme.palette[ownerState?.color || "primary"].main
            }99`,
            "& span": {
              padding: "0px",
            },
          }),
          ...(ownerState?.rectangle && {
            borderRadius: "4px",
            padding: "4px 8px",
            height: "auto",
            background: `${
              theme.palette[ownerState?.color || "primary"].main
            }20`,
            "& span": {
              padding: "0px",
            },
          }),
        }),
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState?.type == "button" && {
            minHeight: "auto",
            marginBottom: "15px",
            "& .MuiTabs-flexContainer": {
              gap: "15px",
            },
            "& button": {
              padding: "8px 16px",
              border: `1px solid ${theme.palette.border.blue}`,
              borderRadius: "8px",
              textTransform: "none",
              minHeight: "auto",
              color: theme.palette.secondary.main,
            },
            "& .Mui-selected": {
              color: `${theme.palette.white.main} !important`,
              background: theme.palette.primary.main,
            },
          }),
          ...(ownerState?.type == "primary" && {
            minHeight: "auto",
            marginBottom: "0px",
            "& button": {
              padding: "8px 16px",
              textTransform: "none",
              minHeight: "auto",
            },
          }),
          ...(ownerState?.type == "filled" && {
            minHeight: "auto",
            marginBottom: "15px",
            "& .MuiTabs-flexContainer": {
              gap: "10px",
              width: "fit-content",
              background: theme.palette.background.default,
              padding: "4px",
              borderRadius: "8px",
            },
            "& button": {
              padding: "8px 16px",
              borderRadius: "8px",
              textTransform: "none",
              minHeight: "auto",
              color: theme.palette.secondary.main,
            },
            "& .Mui-selected": {
              background: theme.palette.white.main,
              color: `${theme.palette.secondary.main} !important`,
            },
          }),
        }),
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          padding: "0px",
        }),
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState?.primary && {
            borderColor: theme.palette.border.blue,
            borderRightWidth: "2px",
          }),
        }),
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState?.bordered && {
            border: `1px solid ${theme.palette.border.blue}`,
            borderRadius: "8px !important",
            margin: "0px !important",
            position: "relative",
            "&::before": {
              display: "none",
            },
            "& .MuiAccordionSummary-root": {
              minHeight: "auto !important",
            },
            "& .MuiAccordionSummary-content": {
              margin: "16px 0px !important",
            },
          }),
        }),
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState?.primary && {
            padding: "16px",
            margin: "8px 16px 16px",
            background: theme.palette.background.default,
            borderRadius: "16px",
            borderTop: `3px solid ${theme.palette.primary.main}`,
          }),
          "& ol": {
            paddingInlineStart: "20px",
            margin: "5px 0px",
          },
          "& ul": {
            paddingInlineStart: "20px",
            margin: "5px 0px",
          },
        }),
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState?.filled && {
            background: theme.palette.primary.main,
            "&:hover": {
              background: theme.palette.primary.main,
            },
          }),
        }),
      },
    },
    MuiTable: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          border: `1px solid ${theme.palette.border.blue}`,
        }),
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          "& .MuiTableCell-root": {
            padding: "10px 16px",
            color: theme.palette.secondary.main,
            borderBottom: "none",
          },
        }),
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          "& .MuiTableCell-root": {
            padding: "10px 16px",
            borderColor: theme.palette.border.blue,
          },
        }),
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          "& .MuiDialog-paper": {
            borderRadius: "8px",
          },
        }),
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          padding: "20px !important",
        }),
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          padding: "0px 20px 20px 20px",
          ...(ownerState?.primary && {
            justifyContent: "start",
          }),
          justifyContent: ownerState?.align || "end",
        }),
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          padding: "16px",
          background: theme.palette.primary.main,
          color: theme.palette.white.main,
          fontSize: "16px",
          fontWeight: 500,
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
        }),
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: ({ theme, ownerState }) => ({
          ...(ownerState?.rounded && {
            borderRadius: "16px",
          }),
        }),
      },
    },
  },
}

export default theme;
